<script setup>
  import { useBrandChannelStore } from '../../store';

  const brandChannelStore = useBrandChannelStore();

  const title = brandChannelStore.tape.brand_channel.title
  const description = brandChannelStore.tape.brand_channel.description
  const titleColor = brandChannelStore.tape.brand_channel.title_color
  
</script>

<template>
  <div class="video-caption">
    <h2 class="video-caption__title" :style="{ color: titleColor }">
      {{ title }}
    </h2>
    <div class="video-caption__text" v-html="description"></div>
  </div>
</template>

<style>
.video-caption__title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 10px;
}

.video-caption__text {
  font-size: 12px;
  color: #666;
}
</style>
